/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Type_OrganizationInputs */

const en_knp_lookup_type_organization = /** @type {(inputs: Knp_Lookup_Type_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization`)
};

const fr_knp_lookup_type_organization = /** @type {(inputs: Knp_Lookup_Type_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation`)
};

const de_knp_lookup_type_organization = /** @type {(inputs: Knp_Lookup_Type_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation`)
};

const it_knp_lookup_type_organization = /** @type {(inputs: Knp_Lookup_Type_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizzazione`)
};

const ru_knp_lookup_type_organization = /** @type {(inputs: Knp_Lookup_Type_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Организация`)
};

const es_knp_lookup_type_organization = /** @type {(inputs: Knp_Lookup_Type_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organización`)
};

const zh_cn2_knp_lookup_type_organization = /** @type {(inputs: Knp_Lookup_Type_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织`)
};

const ja_knp_lookup_type_organization = /** @type {(inputs: Knp_Lookup_Type_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`組織`)
};

const hi_knp_lookup_type_organization = /** @type {(inputs: Knp_Lookup_Type_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संगठन`)
};

const pt_pt2_knp_lookup_type_organization = /** @type {(inputs: Knp_Lookup_Type_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organização`)
};

/**
* | output |
* | --- |
* | "Organization" |
*
* @param {Knp_Lookup_Type_OrganizationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_type_organization = /** @type {((inputs?: Knp_Lookup_Type_OrganizationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Type_OrganizationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_type_organization(inputs)
	if (locale === "de") return de_knp_lookup_type_organization(inputs)
	if (locale === "it") return it_knp_lookup_type_organization(inputs)
	if (locale === "ru") return ru_knp_lookup_type_organization(inputs)
	if (locale === "es") return es_knp_lookup_type_organization(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_type_organization(inputs)
	if (locale === "ja") return ja_knp_lookup_type_organization(inputs)
	if (locale === "hi") return hi_knp_lookup_type_organization(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_type_organization(inputs)
	return en_knp_lookup_type_organization(inputs)
});